<template>
  <a @click="handleLogoClick" :title="$t('dashboard')" class="logo">
    <logo-image :is-minified="isMinified" />
  </a>
</template>

<script setup>
import { useRouter } from 'vue-router';

import LogoImage from './Logos/LogoProfits.vue';

defineProps({
  isMinified: {
    type: Boolean,
    default: false,
  },
});

const router = useRouter();

const handleLogoClick = () => {
  router.push('/dashboard');
};
</script>

<style lang="scss" scoped>
.logo {
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-decoration: none;
}
</style>
